import KngAuditContent from './src/main';

/* istanbul ignore next */
KngAuditContent.install = function(Vue) {
  Vue.component(KngAuditContent.name, KngAuditContent);
};

export default KngAuditContent;
